export default __webpack_public_path__ + "static/media/№ KZ.T.07.E0719 black.dc1bb8bc.svg";